import React, {useState, useEffect} from 'react';

import Cookies from 'utils/cookies';
import {LoadingPage} from 'components/Loading';
import {createId} from '@paralleldrive/cuid2';
import {getAuthBSIDSecret} from 'api/auth';

/**
 * BSIDRegistry is used to register the BSID of the user.
 * - On initial page load, if iaf_bsid cookie does not exist, call the API.
 * - After calling the API, this will generate iaf_bsid (Non-HttpOnly) cookie.}
 */
function BSIDRegistry(props) {
  const {children} = props;

  const [bsid, setBSID] = useState(null);

  useEffect(async () => {
    const cookieBSID = Cookies.bsid;

    if (cookieBSID) {
      setBSID(cookieBSID);
    } else {
      // Call the API, and set the BSID cookie even if successful or not
      getAuthBSIDSecret().finally(() => {
        const newId = createId();
        Cookies.bsid = newId;
        setBSID(newId);
      });
    }
  }, []);

  if (!bsid) return <LoadingPage isLoading />;

  return children;
}

export default BSIDRegistry;
